// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-regions',
    standalone: false,
    templateUrl: './regions.component.html',
})
export class StatisticsVisitorsRegionsComponent implements OnInit {
    domain: any;
    totalVisits: number = 0;
    loading: boolean = false;
    date: any;
    countryCode: string = '';
    countryName: string = '';
    summaryPromise: any = null;
    summary: any = {};
    pages: any[] = [];
    doughnutLabels: any[] = [];
    doughnutData: any[] = [];
    doughnutOptions: any = {};
    promise: any;
    page: number = 1;
    pageSize: number = 10;
    loaded: boolean = false;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.sessionService.domain;
        this.totalVisits = 0;
        this.loading = false;
        this.date = this.dateRangeService.setRangeDates();

        this.countryCode = this.stateService.params.countryCode;
        this.countryName = this.stateService.params.countryName;

        this.summaryPromise = null;
        this.summary = {};

        this.setupDoughnutSettings();
        this.updateDateRange();
    }

    setupDoughnutSettings () {
        this.doughnutLabels = [];
        this.doughnutData = [];
        this.doughnutOptions = {
            legend: {
                display: true,
                position: 'bottom',
                onHover: function (element: any) {
                    element.target.style.cursor = 'pointer';
                },
                onLeave: function (element: any) {
                    element.target.style.cursor = 'default';
                },
            },
            tooltips: {
                callbacks: {
                    title: () => {
                        return this.translateService.getString('Visits');
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
    }

    getPage () {
        this.loading = true;
        const params = {
            limit: 100,
            page: this.page || 1,
            domainId: this.stateService.params.domainId,
            country_code: this.countryCode,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
        };

        const summaryParams = {
            domainId: this.stateService.params.domainId,
            search: this.countryName,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
        };

        this.promise = this.statsRepoService.getRegions(params)
            .then((regions: any) => {
                this.pages = regions;
                this.totalVisits = this.pages.reduce((total, page) => {
                    return total + parseInt(page.visits);
                }, 0);
                this.setupDoughnutData();
            })
            .finally(() => {
                this.loading = false;
            });

        this.summaryPromise = this.statsRepoService.getLocations(summaryParams, contextTokens.NO_PARSE_SEARCH)
            .then((data: any) => {
                if (data.length >= 1) {
                    this.summary = data[0];
                    this.summary.pageviews = 1;

                    if (parseInt(this.summary.visits) > 0 && parseInt(this.summary.avg_time) > 0) {
                        this.summary.avg_time = this.summary.avg_time / this.summary.visits;
                    }

                    if (parseInt(this.summary.visits) > 0 && parseInt(this.summary.bounce_rate) > 0) {
                        const bounceRate = this.summary.bounce_rate / this.summary.visits;
                        this.summary.bounce_rate = this.pipeService.get('monNumber')(bounceRate, '0.[00]%');
                    }

                    if (parseInt(this.summary.visits) > 0 && parseInt(this.summary.actions) > 0) {
                        const avgActions = this.summary.actions / this.summary.visits;
                        this.summary.avg_actions = this.pipeService.get('monNumber')(avgActions, '0.[00]');
                    }
                } else {
                    this.summary = null;
                }
            })
            .finally(() => {
                this.loaded = true;
            });
    }

    setupDoughnutData () {
        let others = 0;
        this.doughnutLabels = [];
        this.doughnutData = [];
        for (let i = 0; i < this.pages.length; i++) {
            if (i < 5) {
                this.doughnutLabels.push(this.pages[i].label);
                this.doughnutData.push(this.pages[i].visits);
            } else {
                others += parseInt(this.pages[i].visits);
            }
        }
        if (this.pages.length > 5) {
            this.doughnutLabels.push(this.translateService.getString('Others'));
            this.doughnutData.push(others);
        }
    }

    pageChange (page: number) {
        this.page = page;
        this.getPage();
    }

    perPageChange (pageSize: number) {
        this.pageSize = pageSize;
        this.getPage();
    }

    updateDateRange () {
        this.paramService.setParams({
            from: moment(this.date.startDate),
            to: moment(this.date.endDate),
            countryName: this.countryName,
        });
        this.getPage();
    }
}
